import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ExtendedModule, FlexModule } from '@angular/flex-layout';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../@shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { PolicyDetailsComponent } from './policy-details.component';
import { PolicyDetailsRoutingModule } from './policy-details.routing.module';

@NgModule({
    declarations: [PolicyDetailsComponent],
    imports: [
        CommonModule,
        MatIconModule,
        PolicyDetailsRoutingModule,
        ExtendedModule,
        FlexModule,
        MatTabsModule,
        SharedModule,
        MatButtonModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
    ],
    exports: [PolicyDetailsComponent],
    providers: [],
})
export class PolicyDetailsModule {}
